


















import { Mutations } from '@/ts/store/Constants';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ImageData from '@/ts/ImageData';

@Component
export default class RemoteImage extends Vue {
    @Prop() public storageGuid!: string;
    @Prop() public imageWidth!: number;
    @Prop() public imageHeight!: number;

    // Lifetime hooks
    constructor() {
        super();
    }

    public mounted() {
        if (!this.$store.state.Images.imageMap[this.storageGuid]) {
            this.$store.commit(Mutations.ADD_REMOTE_IMAGE, {
                guid: this.storageGuid,
                width: this.imageWidth,
                height: this.imageHeight,
            });
        }
    }

    // Class members
    get imageData(): ImageData {
        return this.$store.getters['Images/getImage'](this.storageGuid);
    }

    get dataLoaded(): boolean {
        return (this.imageData != null && this.imageData.hasData);
    }

    get optimalImageData(): string {
        if (this.imageData.originalData !== '') {
            return this.imageData.originalData;
        }

        if (this.imageData.largeData !== '') {
            return this.imageData.largeData;
        }

        return this.imageData.thumbnailData;
    }

    get imageRatio(): number {
        return this.imageWidth / this.imageHeight;
    }

    get imageDimensions(): string {
        const viewportDimensions = this.$store.getters['Viewport/viewportSize'];

        let imageWidth = 0;
        let imageHeight = 0;

        if (this.$store.getters['Viewport/mobileLayout'] === true) {
            imageWidth = 0.6 * viewportDimensions.width;
            imageHeight = imageWidth * (1.0 / this.imageRatio);
        } else {
            imageWidth = 0.1 * viewportDimensions.width;
            imageHeight = imageWidth * (1.0 / this.imageRatio);
        }

        return 'width: ' + Math.ceil(imageWidth) + 'px; height: ' + Math.ceil(imageHeight) + 'px;';
    }
}
